<template>
	<div>
		<div style="width: 100%;margin-bottom: 20px;">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
				<el-breadcrumb-item>业务关系管理</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<!-- 搜索筛选 -->
		<el-form :inline="true" class="user-search" :model="formInline" size="small">
			<el-form-item label="业务员ID:">
				<el-input size="small" placeholder="请输入业务员ID" v-model="formInline.uid" clearable></el-input>
			</el-form-item>
			<el-form-item label="业务员姓名">
				<el-input size="small" clearable placeholder="请输入业务员姓名" v-model="formInline.username"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>

			</el-form-item>
		</el-form>

		<!--列表-->
		<el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
			element-loading-text="拼命加载中" style="width: 100%;">
			<el-table-column prop="uid" label="业务员ID" width="100" align="center">
			</el-table-column>
			<el-table-column prop="username" label="业务员姓名"  align="center">
			</el-table-column>
			<el-table-column sortable prop="allSubUsersNum" label="已绑定用户数"  align="center">
			</el-table-column>
			<el-table-column sortable prop="businessCanActivityUserCount" label="激活用户限额" align="center">
				<!-- <template slot-scope="scope">
					{{scope.row.}}
				</template> -->
			</el-table-column>
			<el-table-column sortable prop="activateSubUserNum" label="已激活用户数"  align="center">
			</el-table-column>
			<el-table-column prop="stock" label="最近三次修改记录"  align="center">
				<template slot-scope="scope">
					<div v-for="(item,index) in scope.row.businessActivitySubUserLogList" :key="index">
						{{index+1}}.
						[{{web.formatTime(item.operTime,'Y-M-D h:m')}}]
						【{{item.username}}】
						<span :style="{color:item.businessActivity=='yes'?'#52BF48':'red'}">
							{{item.businessActivity=='yes'?'激活':'取消激活'}}
						</span>

						【{{item.subUsername}}】
					</div>
				</template>
			</el-table-column>
			<el-table-column align="center" label="操作">
				<template slot-scope="scope">
					<el-button size="mini" type="primary" icon="el-icon-edit"
						@click="handleedit(scope.$index, scope.row)">
						修改激活用户限额
					</el-button>
					<el-button size="mini" type="danger" @click="handleLook(scope.$index, scope.row)">查看完整修改记录
					</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-dialog :visible.sync="dialogVisible" title="查看完整修改记录" width="6000"  :close-on-click-modal="false">
			<el-form :inline="true" class="user-search" :model="complet" size="small">
				<el-form-item label="业务员ID:">
					<el-input size="small" placeholder="请输入业务员ID" v-model="complet.uid" disabled></el-input>
				</el-form-item>
				<el-form-item label="业务员姓名">
					<el-input size="small" disabled placeholder="请输入业务员姓名" v-model="username"></el-input>
				</el-form-item>
				<el-form-item label="用户姓名">
					<el-input size="small" clearable placeholder="请输入用户姓名" v-model="complet.subName"></el-input>
				</el-form-item>
				<el-form-item label="操作时间">
					<datapicker @click="changetime2"></datapicker>
				</el-form-item>
				<el-form-item>
					<el-button size="small" type="primary" icon="el-icon-search" @click="searchComplet">搜索</el-button>

				</el-form-item>
			</el-form>
			<div style="margin-top: 20px;">
				<div v-for="(item,index) in completData" :key="index" style="margin-bottom: 5px;">
					{{index+1}}.
					[{{web.formatTime(item.operTime,'Y-M-D h:m:s')}}]
					<span :style="{color:item.businessActivity=='yes'?'#52BF48':'red'}">
						{{item.businessActivity=='yes'?'激活':'取消激活'}}
					</span>
					【{{item.subUsername}}】
				</div>
			</div>
		</el-dialog>
		<el-dialog :visible.sync="dialogVisible2" title="修改激活用户限额" width="300"  :close-on-click-modal="false">
			<el-form :inline="true" class="user-search" :model="editData" size="small">
				<el-form-item label="业务员ID:">
					<el-input size="small" placeholder="请输入业务员ID" v-model="editData.uid" disabled></el-input>
				</el-form-item>
				<el-form-item label="用户限额:">
					<el-input @input="changeBasic($event)" size="small" placeholder="请输入用户限额"
						v-model="editData.countNum"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button size="small" type="primary" icon="el-icon-edit" @click="editCountNum">修改</el-button>

				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
	import {
		queryAllBusinessSubUser,
		queryActivityUser,
		changeActivityUserCount
	} from '../../api/basisMG.js'
	export default {
		data() {
			return {
				priceEdit: false,
				editId: 0,
				marketPrice: 0,
				username: '',
				listData: [],
				formInline: {},
				loading: false,
				dialogVisible: false,
				dialogVisible2: false,
				formStat: {
					timeStart: '',
					timeEnd: ''
				},
				complet: {
					uid: '',
					subName: '',
					operTimeStart: '',
					operTimeEnd: ''
				},
				completData: [],
				editData: {},
				aaanum:0
			}
		},
		methods: {
			editCountNum() {
				if(this.editData.countNum>this.aaanum){
					let param = this.editData
						changeActivityUserCount(param).then(res => {
							if (res.code == 200) {
								this.dialogVisible2 = false
								this.getALLbusiness(this.formInline)
							}
						})
				}else{
					let param = this.editData
					this.$confirm('是否确定修改?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						changeActivityUserCount(param).then(res => {
							if (res.code == 200) {
								this.dialogVisible2 = false
								this.getALLbusiness(this.formInline)
							}
						})
					})
				}
				
			},
			changeBasic(e) {
				console.log(e)
				this.$forceUpdate()
			},
			handleedit(index, row) {
				this.dialogVisible2 = true
				this.editData.countNum = row.businessCanActivityUserCount
				this.editData.uid = row.uid
				this.aaanum = row.allSubUsersNum
			},
			searchComplet() {
				let param = this.complet
				queryActivityUser(param).then(res => {
					if (res.code == '200') {
						this.completData = res.data
					}
				})
			},
			search() {
				this.getALLbusiness(this.formInline)
			},
			getALLbusiness(params) {
				let param = params
				queryAllBusinessSubUser(param).then(res => {
					if (res.code == '200') {
						this.listData = res.data
					}
				})
			},
			handleLook(index, row) {
				this.dialogVisible = true
				console.log(index, row)
				this.complet.uid = row.uid
				this.username = row.username
			},
			changetime1(val) {
				if (val.length) {
					this.formStat.timeStart = val[0]
					this.formStat.timeEnd = val[1]
				} else {
					this.formStat.timeStart = ""
					this.formStat.timeEnd = ""
				}
			},
			changetime2(val) {
				if (val.length) {
					this.complet.operTimeStart = val[0]
					this.complet.operTimeEnd = val[1]
				} else {
					this.complet.operTimeStart = ""
					this.complet.operTimeEnd = ""
				}
			},
		},
		created() {
			this.getALLbusiness(this.formInline)
		}
	}
</script>

<style>
</style>
